import React from "react";
import { TodoCreateScreenProps } from "./TodoCreateNavigator";
import { LinkProductComponent } from "../TodoEdit/LinkProductComponent";

import { useTodoCreateState } from "./TodoCreateState";

export function TodoCreateLinkProduct(
  props: TodoCreateScreenProps<"TodoCreateLinkProduct">
) {
  const { state, setState } = useTodoCreateState();
  return (
    <LinkProductComponent
      linkedProductIds={state.linkedProductIds}
      onPressProduct={(product) => {
        const isSelected = state.linkedProductIds.includes(product.id);

        setState((prev) => ({
          ...prev,
          linkedProductIds: isSelected
            ? state.linkedProductIds.filter((id) => id !== product.id)
            : [...state.linkedProductIds, product.id],
        }));
      }}
    />
  );
}
